import React from 'react'
import OrganizationMemberListCard from '@/components/OrganizationMemberListCard'

export default function OrganizationMembers() {
    return <OrganizationMemberListCard />
}
